import { Home, Users, BarChart, Settings } from "lucide-react";
import { useState } from "react";

const menuItems = [
  {
    name: "User Management",
    icon: Users,
    subs: ["Applicators", "Customers"],
  },
  {
    name: "Design Overview",
    icon: BarChart,
    subs: ["All Designs"],
  },
  {
    name: "Pricing",
    icon: Home,
    subs: ["Resin Cost", "Create Coupon", "All Coupons"],
  },
  {
    name: "Quick Actions",
    icon: Settings,
    subs: ["Assign Role", "Applicator Review"],
  },
];

export default function Sidebar({
  activeSection,
  setActiveSection,
  isSidebarOpen,
  setIsSidebarOpen,
}) {
  const [openMenu, setOpenMenu] = useState(null);

  return (
    <aside
      className={`tw-fixed md:tw-static tw-top-0 tw-left-0 tw-w-64 tw-h-full tw-rounded-s-md tw-bg-[#00B5ED] tw-text-white tw-p-6 tw-transition-transform ${
        isSidebarOpen
          ? "tw-translate-x-0 tw-mt-20 tw-transition tw-ease-in-out"
          : "tw--translate-x-full"
      } md:tw-translate-x-0`}
    >
      <button
        className="tw-absolute tw-top-6 tw-right-4 tw-text-white md:tw-hidden"
        onClick={() => setIsSidebarOpen(false)}
      >
        ✕
      </button>

      <h2 className="tw-text-xl tw-font-bold tw-pl-2">Dashboard</h2>
      <div className="tw-border-white tw-border-b-2 tw-my-4 -tw-mx-6"></div>
      <nav className="tw-space-y-4">
        {menuItems.map(({ name, icon: Icon, subs }) => (
          <div key={name}>
            <button
              onClick={() => {
                setOpenMenu(openMenu === name ? null : name);
              }}
              className={`tw-flex tw-items-center hover:tw-bg-white hover:tw-text-black tw-gap-2 tw-w-full tw-px-3 tw-py-2 tw-rounded-lg ${
                openMenu === name || subs.includes(activeSection)
                  ? "tw-bg-white tw-mb-2 tw-text-primary"
                  : "tw-bg-[#00B5ED]"
              }`}
            >
              <Icon className="tw-w-5 tw-h-5" />
              {name}
            </button>
            {openMenu === name &&
              subs.map((sub) => (
                <button
                  key={sub}
                  onClick={() => {
                    setActiveSection(sub);

                    // OPEN IN NEW TAB
                    // window.open(
                    //   `/dashboard/${sub.replace(/\s+/g, "-").toLowerCase()}`,
                    //   "_blank",
                    // );

                    setIsSidebarOpen(false);
                  }}
                  className={`tw-ml-6 tw-text-sm tw-py-1 tw-px-2 tw-w-[70%] tw-items-center tw-text-left tw-rounded-md tw-border-b
        ${
          activeSection === sub
            ? "tw-border-white tw-bg-gray-500 tw-text-white tw-opacity-100 hover:tw-border-white hover:tw-bg-transparent"
            : "tw-border-transparent tw-text-white tw-opacity-100 hover:tw-border-white hover:tw-bg-transparent hover:tw-text-gray-500"
        }
        hover:tw-opacity-100`}
                >
                  {sub}
                </button>
              ))}
          </div>
        ))}
      </nav>
    </aside>
  );
}
